<template>
    <div class="m-stepProgressBar">
        <div
            class="d-flex gap-1 align-items-center justify-content-between mb-5 mt-4 mt-md-0"
        >
            <h1 class="mb-0">Dodawanie nowej promocji</h1>
            <slot></slot>
        </div>
        <div class="m-stepProgressBar__mobile text-primary">
            <div
                role="progressbar"
                :aria-valuenow="progress"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="
                    `--value:${progress}; --active: ${indexOfActive +
                        1}; --length: ${steps.length}; --text: ${indexOfActive +
                        1} z ${steps.length}`
                "
            ></div>
            <h4 v-html="label || steps.find(step => step.active).label"></h4>
        </div>
        <ul class="m-stepProgressBar__desktop m-stepProgressBar__steps">
            <li
                class="m-stepProgressBar__step"
                :class="[
                    { '--active': !!step.active },
                    { '--disabled': step.disabled },
                    {
                        '--last': idx + 1 === numberOfEnabled
                    }
                ]"
                v-for="(step, idx) in steps"
                @click="onStepClick(idx)"
                :key="idx"
            >
                <span class="m-stepProgressBar__stepCircle mb-2"></span>
                <p class="m-stepProgressBar__stepLabel mb-0">
                    {{ step.label }}
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'StepProgressBar',
    props: {
        steps: {
            type: Array,
            required: true
        },
        label: {
            type: String,
            required: false
        }
    },
    computed: {
        numberOfEnabled() {
            return this.steps.filter(el => !el.disabled).length
        },
        indexOfActive() {
            return this.steps.map(el => el.active).indexOf(true)
        },
        progress() {
            return (this.indexOfActive + 1) * (100 / this.steps.length)
        }
    },
    methods: {
        onStepClick(idx) {
            if (this.steps[idx].disabled) return
            this.$emit('changeStep', idx)
        }
    }
}
</script>
